export default "__VITE_ASSET__SR3ZD$kL__"